/**
 * Returns true for values that are treated as "no value" in user custom
 * attributes. Such keys should be removed instead of stored.
 * `false`, `0` and empty arrays are considered valid values.
 */
const isEmptyUserCustomAttributeValue = (value: unknown) =>
  value === null || value === undefined || value === '';

export default isEmptyUserCustomAttributeValue;
